var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('formulario-campania',{attrs:{"campania":_vm.campania,"descuentos":_vm.descuentos},on:{"submit":_vm.actualizar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }